import React, { type ReactNode } from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { Skeleton } from '@atlassian/jira-servicedesk-insight-shared-ui/src/ui/skeleton/styled.tsx';

const AttributeRow = () => (
	<FlexContainer>
		<Skeleton width="30%" height="24px" />
		<Skeleton width="70%" height="24px" />
	</FlexContainer>
);

export const AttributesSkeleton = () => (
	<Wrapper>
		<AttributeRow />
		<AttributeRow />
		<AttributeRow />
		<AttributeRow />
		<AttributeRow />
	</Wrapper>
);

const Wrapper = ({ children }: { children?: ReactNode }) => (
	<Box xcss={wrapperStyles}>{children}</Box>
);

const FlexContainer = ({ children }: { children?: ReactNode }) => <Flex>{children}</Flex>;

const wrapperStyles = xcss({
	margin: 'space.negative.100',
});
